// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Studies-StudyDetails-module__studySummaryDescriptor";
var _2 = "webpack-concepts-Studies-StudyDetails-module__studySummaryTitle";
var _3 = "webpack-concepts-Studies-StudyDetails-module__subtleDescriptor";
export { _1 as "studySummaryDescriptor", _2 as "studySummaryTitle", _3 as "subtleDescriptor" }
